import React, { useContext } from 'react';
import { SmartContext } from '../../../../../../library/Core/SmartContext';

const EventDetailsModal = ({ eventData, eventType }: { eventData: any[], eventType: string }) => {
    const { state, dispatch } = useContext(SmartContext);
    const showFlag = state?.modalFlags?.showAffinityEventsModal;

    const typeField = eventType === 'networkingEvents' 
        ? 'networkingEventsType' 
        : eventType === 'benefitsAvailed'
        ? 'benefitsAvailedTypes'
        : 'lAndDEventsType';

    const title = eventType === 'networkingEvents' 
        ? 'Networking Events' 
        : eventType === 'benefitsAvailed'
        ? 'Benefits Availed'
        : 'L&D Events';

    const filePathField = eventType === 'networkingEvents' 
        ? 'networkingEventsFilePath' 
        : eventType === 'benefitsAvailed'
        ? null  // no file upload for benefits
        : 'lAndDEventsFilePath';

    const eventTypeCounts = eventData.reduce((acc: Record<string, number>, event: any) => {
        const type = event[typeField];
        if (type) {
            acc[type] = (acc[type] || 0) + 1;
        }
        return acc;
    }, {});

    const hasFilesToDownload = filePathField 
    ? eventData.some(event => event[filePathField]) 
    : false;

   const handleDownload = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!filePathField) return;
    eventData.forEach(event => {
        if (event[filePathField]) {
            window.open(event[filePathField], '_blank');
        }
    });
};

    return (
        <div
            id="update-affinity-data"
            className={`modal fade ${showFlag ? 'show' : ''}`}
            tabIndex={-1}
            role="dialog"
            style={{ display: showFlag ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-dialog-centered max-800 mx-auto">
                <div className="modal-content">
                    <div className="modal-header p-4 height-70 border-0 bg-gray-f2">
                        <h5 className="modal-title" id="staticBackdropLabel">{title}</h5>
                        <button
                            type="button"
                            className="btn-close btn-close-small"
                            onClick={() => {
                                dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showAffinityEventsModal' } });
                            }}
                            aria-label="Close"></button>
                    </div>
                  <div className="modal-body p-4">
                    {eventType === 'benefitsAvailed' ? (
                        <ul className="list-unstyled">
                            {eventData
                                .filter(item => item && Object.keys(item).length > 0)
                                .map((item, index) => (
                                    <li key={index} className="d-flex align-items-center gap-2 mb-2">
                                        <i className="tick"></i>
                                        {item.benefitsAvailedTypes || item.benefitName}
                                    </li>
                                ))
                            }
                        </ul>
                    ) : (
                        <>
                            <p>
                                {Object.entries(eventTypeCounts).map(([eventType, count]) => (
                                    <span key={eventType}>
                                        {count} {eventType}
                                        <br/>
                                    </span>
                                ))}
                            </p>
                            {hasFilesToDownload && (
                                <p>
                                    <a href="#" onClick={handleDownload}>Download</a> Uploaded Files
                                </p>
                            )}
                        </>
                    )}
                </div>
                </div>
            </div>
        </div>
    );
};

export default EventDetailsModal;
